import { render } from "./Fee.vue?vue&type=template&id=4e882898&scoped=true"
import script from "./Fee.vue?vue&type=script&lang=js"
export * from "./Fee.vue?vue&type=script&lang=js"

import "./Fee.vue?vue&type=style&index=0&id=4e882898&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e882898"]])

export default __exports__